<template>
  <div class="post-box">
    <!--<div class="post-media"
         :style="{ backgroundImage: 'url(http://icons.iconarchive.com/icons/martz90/circle-addon2/512/help-icon.png)'}"></div>-->
    <div class="post-content text-left">
      <h6 class="post-title">
        <!--{{ t.help_usage }}-->
        Canli NBA Keyfi
      </h6>
      <div class="mobile-image">
        <img src="https://www.sonperiyot.com/wp-content/uploads/nba-maclari-sonuclari-ve-program.jpg" alt="mobile-qr">
      </div>
      <div class="mobileBox-text">
        <div>Tüm NBA Karşılaşmaları Canlı yayınla sizlerle!</div>
      </div>
      <p></p>
      <!--<a class="post-link" href="#"><i class="os-icon os-icon-arrow-right7"></i>
          <span>{{ t.detail }}</span>
      </a>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'nbaTv',
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sportsbook/widget/nbaTv.vue